export default "__VITE_ASSET___QFjtOGl__"